interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function getPages(page: number, total: number): (number | string)[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = getPages(page, totalPages);

  return (
    <nav aria-label="分页导航" className="mt-8 flex items-center justify-center gap-2">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((p, i) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`h-9 w-9 cursor-pointer rounded-md text-sm font-medium transition-colors ${
              p === page
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${i}`} className="px-1 text-foreground-400">
            {p}
          </span>
        ),
      )}

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}